export default "__VITE_ASSET__BH4eH$9H__"